import { TableRow } from "./table-row";

export class TableGroup {
  public label: string;
  public fieldname: string;
  public rows: TableRow[];
  public loaded: TableRow[];
  public groups: TableGroup[];

  public level: string;
  public hidden: boolean;
  public collapsed: boolean;

  public constructor(label: string) {
    this.label = label;
    this.fieldname = "";
    this.rows = [];
    this.loaded = [];
    this.groups = [];

    this.level = "0";
    this.hidden = false;

    this.collapsed = false;
  }

  public getSelected(): TableRow[] {
    return this.loaded.filter((row) => row.selected && !row.deleted);
  }

  public selectAll(select: boolean): void {
    for (const row of this.loaded) {
      row.select(select);
    }
  }
}
